import { render, staticRenderFns } from "./BranchSettingsTab.vue?vue&type=template&id=6a12852e&scoped=true"
import script from "./BranchSettingsTab.vue?vue&type=script&lang=js"
export * from "./BranchSettingsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a12852e",
  null
  
)

export default component.exports